import currency from 'currency.js';

export function roundNumberToNearestCent(number) {
  var curr = currency(number);
  return curr.value;
}

export function isAValidNumber(number) {
  return number !== undefined && number !== null && !NaN(number);
}
